export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "78ae9f8b-8735-4613-99b4-3b320f3f79ad",
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID || "f68a9123-f249-4628-b845-4ab6bdca5e77"}`,
      redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || "https://events.redrocket-apps.energy/",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    }
  };
  
  export const loginRequest = {
    scopes: [
      "User.Read",
      "User.Read.All",
      "Calendars.ReadWrite",
      "OnlineMeetings.ReadWrite",
      "profile",
      "email",
      "Place.Read.All",
      "offline_access"
    ]
  };

  export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const protectedResources = {
    graphMe: {
        endpoint: "https://graph.microsoft.com/v1.0/me",
        scopes: ["User.Read","offline_access"]
    },
    meetings: {
        endpoint: "https://graph.microsoft.com/v1.0/me/onlineMeetings",
        scopes: [
          'offline_access',
          'Calendars.Read.Shared',
          'Calendars.ReadWrite',
          'email',
          'GroupMember.Read.All',
          'OnlineMeetings.ReadWrite'
      ]
    }
};